import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { QueryKey } from '@/lib/query-client';
import { getAllClassifiers } from '@/lib/services/classification.service';
import useFeature from '@/hooks/use-feature.hook';
import { FC } from 'react';
import { useQuery } from 'react-query';
import EntityControlList from './entity-control-list';
import IntentControlList from './intent-control-list';

interface Props {
  policy: PolicyModelV1;
  orgPolicy?: PolicyModelV1;
  formHandle: FormHandle<PolicyModelV1>;
  readonly: boolean;
}

const ClassifierControlsV1: FC<Props> = ({ formHandle, readonly, policy, orgPolicy }) => {
  const { hasClassifiers } = useFeature();
  const { data, refetch } = useQuery([QueryKey.ClassifiersList], () => getAllClassifiers());
  const classifiers = data || [];

  return (
    <>
      <IntentControlList
        formHandle={formHandle}
        readonly={readonly}
        policy={policy}
        orgPolicy={orgPolicy}
        classifiers={classifiers}
        refetch={refetch}
      />
      {hasClassifiers && (
        <EntityControlList
          formHandle={formHandle}
          readonly={readonly}
          policy={policy}
          orgPolicy={orgPolicy}
          classifiers={classifiers}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default ClassifierControlsV1;
